import { ListManagerFrontendError } from './ListManagerFrontendError';

// Superclass for errors involving API calls. Can include client failures or
// server errors
export class ApiError extends ListManagerFrontendError {
  static errorName = 'ApiError';
}
